var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{staticClass:"audio-message",attrs:{"src":_vm.src,"controls":_vm.controls}})
}
var staticRenderFns = []

export { render, staticRenderFns }